import { TransactionOperation } from 'further-types/lp/transaction';
import { round, sumBy } from 'lodash';
import type { ReconcilableTransaction } from './useReconcilableTransactions';

export default function checkMutualReconciliationMode(
  reconcilableTransactions: Array<ReconcilableTransaction>,
) {
  const selectedReconcilableTransactions = reconcilableTransactions.filter(
    (t) => t.isSelected,
  );

  if (!selectedReconcilableTransactions.length) {
    return false;
  }

  const payableAmountSelected = sumBy(selectedReconcilableTransactions, (t) =>
    t.isPayable && t.operationType === TransactionOperation.Credit
      ? t.unreconciledAmountTcy
      : 0,
  );
  const receivableAmountSelected = sumBy(
    selectedReconcilableTransactions,
    (t) =>
      t.isReceivable && t.operationType === TransactionOperation.Debit
        ? t.unreconciledAmountTcy
        : 0,
  );

  return (
    !!payableAmountSelected &&
    !!receivableAmountSelected &&
    round(payableAmountSelected, 2) === round(receivableAmountSelected, 2)
  );
}
